import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../Css/Tooltip.css';
import { faHomeAlt, faGear, faUserCircle, faPlus, faSearch, faUserGroup, faX, faSignOut, faBuilding, faBars } from '@fortawesome/free-solid-svg-icons';
import { FaChevronDown, FaRegBell,FaSpinner,FaCheckCircle,FaSearch,FaHistory,FaBuilding } from 'react-icons/fa';
import { requestPermission, handleForegroundNotifications } from '../../push-notifications';
import { messaging,messagingPromise, getToken, onMessage } from '../../firebase-config';
import { clearUserFromServiceWorker } from '../../utils/serviceWorkerUtils';
import NotificationCenter from '../QuickbuyOrderManagement/components/NotificationCenter'
import { decryptData,encryptData } from "../../utils/storageCrypto";
import { useNotification } from '../../context/NotificationContext';

const Navbar = () => {
  const navigate = useNavigate();
  const [searchDropDown, setSearchDropDown] = useState(false);
  const [userDropDown, setUserDropDown] = useState(false);
  const [orgPopUp, setOrgPopUp] = useState(false);
  const [type, setType] = useState('');
  const [userData, setUserData] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [roleName, setRoleName] = useState('');
  const [hubName, sethubName] = useState('');
  const [hubNumber, sethubNumber] = useState('');
  const { notifications } = useNotification();
  //const [notifications, setNotifications] = useState([]);  // To store notifications
 // console.log("notifications:",notifications)
  //const [notificationCount, setNotificationCount] = useState(0);  // To track unread notifications
 // const [isNotificationPopupOpen, setIsNotificationPopupOpen] = useState(false);  // For controlling popup visibility
 
  // Hub switching state
  const [userHubs, setUserHubs] = useState([]);          // list of hubs assigned to the user
  const [hubDropDown, setHubDropDown] = useState(false);   // toggles the hub switcher popup
  const [currentHubId, setCurrentHubId] = useState('');    // currently selected hub's _id
  const [hubsLoading, setHubsLoading] = useState(false);
  // Search
  const [hubSearch, setHubSearch] = useState("");
  // Recently used hubs
  const [recentHubs, setRecentHubs] = useState([]);

  const ref = useRef(null);
  const hubRef = useRef(null);
  const [bellJingle, setBellJingle] = useState(false);
const previousNotificationCount = useRef(0);
  const List = ['Items', 'Customers', 'Vendors', 'Quotes'];

const notificationCount = Array.isArray(notifications)
  ? notifications.filter(
      n =>
        n?.active === true ||
        n?.data?.active === true ||
        n?.data?.active === "true"
    ).length
  : 0;

useEffect(() => {
  //requestPermission(); // Ask for permission on mount
  //handleForegroundNotifications(); // Setup foreground handler
}, []);

useEffect(() => {
  const currentCount = Array.isArray(notifications)
    ? notifications.length
    : 0;

  // Only jingle when count INCREASES
  if (
    previousNotificationCount.current > 0 &&
    currentCount > previousNotificationCount.current
  ) {
    setBellJingle(true);

    const timer = setTimeout(() => {
      setBellJingle(false);
    }, 800);

    previousNotificationCount.current = currentCount;

    return () => clearTimeout(timer);
  }

  previousNotificationCount.current = currentCount;
}, [notifications]);

/* const handleForegroundNotifications = () => {
  console.log("entered handleForegroundNotifications function")
  onMessage(messaging, (payload) => {
    console.log("Message received: ", payload);
    setNotifications((prev) => [
      ...prev,
      {
        title: payload?.notification?.title,
        body: payload?.notification?.body,
        time: new Date().toLocaleString()
      },
    ]);
    setNotificationCount(prevCount => prevCount + 1);
  });
}; */

/* const handleForegroundNotifications = () => {
        messagingPromise.then((messaging) => {
            if (messaging) {
                onMessage(messaging, (payload) => {
                    console.log('🔔 Foreground notification:', payload);
                    // Show custom toast or alert here
                    setNotifications((prev) => [
      ...prev,
      {
        title: payload?.notification?.title,
        body: payload?.notification?.body,
        time: new Date().toLocaleString()
      },
    ]);
    setNotificationCount(prevCount => prevCount + 1);
                });
            }
        });
}; */



  useEffect(() => {
    const storedUserData = sessionStorage.getItem('userData');
    const decryptedUserData = decryptData(storedUserData);
    if (decryptedUserData) {
      setUserData(JSON.parse(decryptedUserData));
    }
    const storedRoleName = sessionStorage.getItem('roleName');
    const decryptedRoleName = decryptData(storedRoleName);
    if (decryptedRoleName) {
      setRoleName(decryptedRoleName);
    }
    const storedhubName = sessionStorage.getItem('hubName');
    const decryptedhubName = decryptData(storedhubName);
    if (decryptedhubName) {
      sethubName(decryptedhubName);
    }
    const storedhubNumber = sessionStorage.getItem('hubNumber');
    const decryptedhubNumber = decryptData(storedhubNumber);
    if (decryptedhubNumber) {
      sethubNumber(decryptedhubNumber);
    }
    // Restore the currently selected hub's id, if it was set before (primary hub id set at login)
    const storedHubId = sessionStorage.getItem('hubId');
    const decryptedHubId = decryptData(storedHubId);
    if (decryptedHubId) {
      setCurrentHubId(decryptedHubId);
    }
  }, []);

  // Fetch notifications from API
/*   const fetchNotifications = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/notifications`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': sessionStorage.getItem('token')
        }
      });
  
      const data = await response.json();
  
      if (response.ok) {
        setNotifications(data.notifications); // Assuming the API returns an array of notifications
        setNotificationCount(data.unreadCount); // Assuming the API returns unread notification count
      } else {
        console.error('Failed to fetch notifications');
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  useEffect(() => {
    fetchNotifications(); // Fetch notifications when the component mounts
    const interval = setInterval(fetchNotifications, 60000); // Refresh notifications every 60 seconds
    return () => clearInterval(interval); // Clear interval on component unmount
  }, []); */

  // Fetch the hubs assigned to this user once we know who they are
  useEffect(() => {
    const userId = userData?._id || userData?.userId;
    if (userId) {
      fetchUserHubs(userId);
    }
  }, [userData]);


  useEffect(() => {
  const stored = localStorage.getItem("recentHubs");

  if (stored) {
    try {
      setRecentHubs(JSON.parse(stored));
    } catch {
      setRecentHubs([]);
    }
  }
  }, []);

  const fetchUserHubs = async (userId) => {
    setHubsLoading(true);
    try {
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);

      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}hub/get-hubs-by-userId?userId=${userId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        }
      );

      const data = await response.json();
      console.log("user hubs data:",data);

      if (response.ok && data?.success) {
        setUserHubs(data.data || []);
      } else {
        // 404 with "No hubs assigned" or any other failure -> empty list, fail quietly
        setUserHubs([]);
        if (data?.message) {
          console.warn('Fetch hubs:', data.message);
        }
      }
    } catch (error) {
      console.error('Error fetching user hubs:', error);
      setUserHubs([]);
    } finally {
      setHubsLoading(false);
    }
  };

  const handleDropDownToggle = () => {
    setSearchDropDown(!searchDropDown);
  };

  const handleClickItem = (item) => {
    setType(item);
    setSearchDropDown(false);
  };

  const handleChangeSearch = () => {
    setSearchDropDown(false);
  };

  const handleUserClick = () => {
    setUserDropDown(!userDropDown);
  };

  const handleOrgClick = () => {
    setOrgPopUp(true);
  };

  const handleOrgClose = () => {
    setOrgPopUp(false);
  };

  // Toggle the hub switcher popup beside the profile icon
  const handleHubIconClick = () => {
    setHubDropDown(!hubDropDown);
  };

  const handleHubSelect = (hub) => {
    const hubId = hub?._id;

    const hubNameVal =
      hub?.hub_name ||
      hub?.hubName ||
      hub?.name ||
      "";

    const hubNumberVal =
      hub?.hub_number ||
      hub?.hubNumber ||
      "";

    try {
      sessionStorage.setItem("hubId", encryptData(hubId));
      sessionStorage.setItem("hubName", encryptData(hubNameVal));
      sessionStorage.setItem("hubNumber", encryptData(hubNumberVal));

      setCurrentHubId(hubId);
      sethubName(hubNameVal);
      sethubNumber(hubNumberVal);

      // -----------------------------
      // Recently Used Hubs
      // -----------------------------
      const updatedRecent = [
        hub,
        ...recentHubs.filter(h => h._id !== hub._id)
      ].slice(0, 5);

      setRecentHubs(updatedRecent);

      localStorage.setItem(
        "recentHubs",
        JSON.stringify(updatedRecent)
      );

    } catch (error) {
      console.error("Error switching hub:", error);
    }

    setHubDropDown(false);
  };

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setSearchDropDown(false);
      setUserDropDown(false);
      //setOrgPopUp(false);
      //setIsNotificationPopupOpen(false);
    }
  };

  const handleClose = () => {
    setUserDropDown(false);
  };

  const handleLogout = async () => {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/user/user-logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
  
      const data = await response.json();
  
      if (response.ok) {
        localStorage.removeItem('LoginData');
        sessionStorage.clear();

         // Clear service worker user data
         clearUserFromServiceWorker();

        navigate('/bb');
      } else if (response.status === 401) {
        // Token might be expired or invalid, clear storage and redirect to login
        localStorage.removeItem('LoginData');
        sessionStorage.clear();
          // Clear service worker user data
          clearUserFromServiceWorker();

        navigate('/bb'); 
      }else{
        console.error('Logout failed:', data.message);
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const handleLogoClick = () => {
    navigate('/bb/app/home');
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

/*   const handleNotificationClick = () => {
    setIsNotificationPopupOpen(!isNotificationPopupOpen);
    if (isNotificationPopupOpen) {
      setNotificationCount(0);  // Reset count when popup is opened
    }
  }; */


/*   const handleNotificationClick = () => {
  const isOpening = !isNotificationPopupOpen;
  setIsNotificationPopupOpen(isOpening);
  
  if (isOpening) {
    setNotificationCount(0); // Reset count only when opening
  }
}; */

const filteredHubs = userHubs.filter((hub) => {

  const query = hubSearch.toLowerCase();

  return (
    hub?.hub_name?.toLowerCase().includes(query) ||
    hub?.hub_number?.toLowerCase().includes(query) ||
    hub?.zoneId?.zone_name?.toLowerCase().includes(query)
  );

});

  return (
    /*{overflow-hidden is removed when notifcations center is added}*/
    <div className="bg-[#21263c] text-[0.8125rem] font-normal w-full h-full flex items-center justify-between py-2">
      <div className="flex flex-row space-x-4">
        <div className='w-[12.5rem] px-3'>
          <div className='flex flex-row'>
            <img src={'/log_ht.png'} alt="Logo" className="h-8 w-50 text-white" />
{/*             <img className="w-8 h-8 cursor-pointer" src='/BB.png' alt="Brick Bucket Logo" onClick={handleLogoClick} />
            <p className="text-xl text-white ml-2">Brickbucket</p> */}
          </div>
        </div>
      </div>

      <div className="hidden md:flex items-center">
        <div className="flex items-center flex-row text-white space-x-6 mx-2">
          <p className="text-[1rem]">Welcome {userData?.username}</p>
        </div>
{/*         <button className="text-white px-4 py-2 mx-2 text-[1rem] hover:bg-[#f7525a] hover:text-white" onClick={handleOrgClick}>
          {hubName}
        </button> */}
        <div className="flex items-center flex-row space-x-6 mx-2">
{/*         <div className="relative mx-2 cursor-pointer" onClick={handleNotificationClick}>
          <FaRegBell className="text-white w-5 h-5" />
          {notificationCount > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full text-xs w-4 h-4 flex items-center justify-center">
      {notificationCount}
    </span>
          )}
        </div> */}
{/* latest        <NotificationCenter/>
 */}

          {/* Action Center Bell */}
          <div className="relative">

            <button
              onClick={() => {
                // ONLY open when admin clicks
                window.dispatchEvent(
                  new CustomEvent('open-action-center')
                );
              }}
              className="
                relative
                w-11
                h-11
                rounded-full
                bg-white/10
                hover:bg-white/20
                border
                border-white/10
                flex
                items-center
                justify-center
                transition-all
              "
              title="Action Center"
            >

              <FaRegBell
                className={`
                  text-white
                  text-xl
                  ${bellJingle ? "animate-bell-jingle" : ""}
                `}
              />

              {notificationCount > 0 && (
                <span
                  className="
                    absolute
                    -top-1
                    -right-1
                    min-w-[20px]
                    h-5
                    px-1
                    bg-red-500
                    text-white
                    text-[10px]
                    font-bold
                    rounded-full
                    flex
                    items-center
                    justify-center
                    border-2
                    border-[#21263c]
                  "
                >
                  {notificationCount > 99
                    ? "99+"
                    : notificationCount}
                </span>
              )}

            </button>

          </div>

           {/* Hub switcher - sits beside the profile icon */}
           <div className="relative" ref={hubRef}>
            <button
              onClick={handleHubIconClick}
              className="
                flex
                items-center
                rounded-xl
                px-3
                py-2
                bg-white/10
                border
                border-white/10
                hover:bg-white/20
                transition-all
            "
            >

                <div className="w-10 h-10 rounded-full bg-[#f7525a] flex items-center justify-center">
                    <FaBuilding className="text-white text-lg"/>
                </div>

                <div className="ml-3 text-left">

                    <div className="text-xs text-gray-300">
                        Current Hub
                    </div>

                    <div className="font-semibold text-white max-w-[170px] truncate">
                        {hubName}
                    </div>

                </div>

                <FaChevronDown
                    className={`ml-3 transition-transform text-white ${
                        hubDropDown ? "rotate-180" : ""
                    }`}
                />

            </button>
 
            {hubDropDown && (
              <div className="absolute right-0 top-14 w-[380px] bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden z-50">

                {/* Header */}
                <div className="px-5 py-4 border-b bg-gradient-to-r from-[#f7525a] to-[#ff747b] text-white">

                  <div className="text-lg font-semibold">
                    Switch Hub
                  </div>

                  <div className="text-xs opacity-90">
                    Search and switch between your assigned hubs
                  </div>

                </div>

                {/* Search */}

                <div className="p-4 border-b">

                  <div className="relative">

                    <FaSearch className="absolute left-3 top-3 text-gray-400" />

                    <input
                      type="text"
                      value={hubSearch}
                      onChange={(e) => setHubSearch(e.target.value)}
                      placeholder="Search hub name, number or zone..."
                      className="w-full border rounded-xl pl-10 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#f7525a]"
                    />

                  </div>

                </div>

                {/* Loader */}

                {hubsLoading && (

                  <div className="flex flex-col items-center justify-center py-12">

                    <FaSpinner className="animate-spin text-3xl text-[#f7525a]" />

                    <p className="mt-3 text-sm text-gray-500">
                      Loading hubs...
                    </p>

                  </div>

                )}

                {/* Data */}

                {!hubsLoading && (

                  <div className="max-h-[450px] overflow-y-auto">

                    {/* Current Hub */}

                    <div className="px-4 pt-4">

                      <div className="text-xs uppercase text-gray-400 font-semibold mb-2">
                        Current Hub
                      </div>

                      {userHubs
                        .filter(h => h._id === currentHubId)
                        .map(hub => (

                          <button
                            key={hub._id}
                            className="w-full border rounded-xl bg-red-50 border-[#f7525a] p-4 text-left mb-4"
                          >

                            <div className="flex justify-between">

                              <div>

                                <div className="font-semibold text-gray-800">

                                  {hub.hub_name}

                                </div>

                                <div className="text-sm text-gray-500 mt-1">

                                  {hub.hub_number}

                                </div>

                                <div className="inline-flex mt-2 px-2 py-1 rounded-full bg-white text-xs text-gray-600">

                                  {hub.zoneId?.zone_name}

                                </div>

                              </div>

                              <FaCheckCircle className="text-green-500 text-xl" />

                            </div>

                          </button>

                        ))}

                    </div>

                    {/* Recent */}

{/*                     {recentHubs.length > 0 && (

                      <div className="px-4">

                        <div className="flex items-center text-xs uppercase text-gray-400 font-semibold mb-2">

                          <FaHistory className="mr-2" />

                          Recently Used

                        </div>

                        {recentHubs.map((hub) => (

                          <button
                            key={hub._id}
                            onClick={() => handleHubSelect(hub)}
                            className="w-full flex justify-between items-center rounded-xl px-4 py-3 hover:bg-gray-50 transition mb-1"
                          >

                            <div>

                              <div className="font-medium">

                                {hub.hub_name}

                              </div>

                              <div className="text-xs text-gray-500">

                                {hub.hub_number}

                              </div>

                            </div>

                            {hub._id === currentHubId && (

                              <FaCheckCircle className="text-green-500"/>

                            )}

                          </button>

                        ))}

                      </div>

                    )} */}

                    {/* All Hubs */}

                    <div className="px-4 mt-4">

                      <div className="flex justify-between items-center mb-3">

                        <span className="text-xs uppercase text-gray-400 font-semibold">

                          All Hubs

                        </span>

                        <span className="text-xs text-gray-500">

                          {filteredHubs.length}

                        </span>

                      </div>

                      {filteredHubs.length === 0 ? (

                        <div className="text-center py-10">

                          <FaBuilding className="mx-auto text-3xl text-gray-300"/>

                          <div className="mt-3 font-medium text-gray-600">

                            No hubs found

                          </div>

                          <div className="text-sm text-gray-400">

                            Try another search.

                          </div>

                        </div>

                      ) : (

                        filteredHubs.map((hub) => {

                          const isActive = hub._id === currentHubId;

                          return (

                            <button

                              key={hub._id}

                              onClick={() => handleHubSelect(hub)}

                              className={`

                              w-full

                              mb-2

                              rounded-xl

                              border

                              transition-all

                              p-4

                              text-left

                              hover:border-[#f7525a]

                              hover:bg-red-50

                              ${

                                isActive

                                ? "border-[#f7525a] bg-red-50"

                                : "border-gray-200"

                              }

                              `}

                            >

                              <div className="flex justify-between">

                                <div>

                                  <div className="font-semibold text-gray-800">

                                    {hub.hub_name}

                                  </div>

                                  <div className="text-sm text-gray-500 mt-1">

                                    {hub.hub_number}

                                  </div>

                                  {hub.zoneId?.zone_name && (

                                    <div className="inline-flex mt-2 px-2 py-1 rounded-full bg-gray-100 text-xs">

                                      {hub.zoneId.zone_name}

                                    </div>

                                  )}

                                </div>

                                {isActive && (

                                  <FaCheckCircle className="text-green-500 text-xl"/>

                                )}

                              </div>

                            </button>

                          );

                        })

                      )}

                    </div>

                  </div>

                )}

              </div>
            )}
           </div>
          <FontAwesomeIcon icon={faUserCircle} className="cursor-pointer text-4xl text-white mx-2" onClick={handleUserClick} />
        </div>
      </div>

      {userDropDown && (
        <div ref={ref} className="absolute right-0 z-50 top-12 bg-white shadow-md border-[#6c7184] rounded-[0.5rem] w-96">
          <div className="p-4 bg-[#fbfbfb]">
            <div className="flex flex-col p-2">
              <div className="flex flex-row justify-between pb-2">
                <div className="flex flex-row">
                  <div>
                    <img className="rounded-md w-8 h-8 cursor-pointer" src='/usericon.gif' alt="User Icon" />
                  </div>
                  <div className="mt-2 ml-2">
                    <p>{userData?.username}</p>
                    <p className="font-semibold">{roleName}</p>
                    <p>{hubName}</p>
                  </div>
                </div>
                <div>
                  <button title="" data-tooltip="close" style={{ '--tooltip-bg': 'black' }} onClick={handleClose}>
                    <FontAwesomeIcon icon={faX} className="cursor-pointer text-md text-[#f7525a] mx-2" />
                  </button>
                </div>
              </div>
              <div className="p-2 border-t border-b flex justify-end">
                <div>
                  <button onClick={handleLogout} className="text-[#f7525a] text-md">
                    <FontAwesomeIcon icon={faSignOut} className="cursor-pointer text-md text-[#f7525a] mx-2" />
                    Sign Out
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

{/*       {orgPopUp && (
        <div ref={ref} className="absolute right-0 z-10 top-12 bg-white shadow-md border-[#6c7184] rounded-[0.5rem] w-96">
          <div className="p-4 bg-[#fbfbfb]">
            <div className="flex flex-col p-2">
              <div className="flex flex-row justify-between pb-2">
                <div className="flex flex-row">
                  <div>
                    <FontAwesomeIcon icon={faBuilding} className="cursor-pointer w-8 h-8 text-md text-[#f7525a] mt-3 mx-2" />
                  </div>
                  <div className="mt-2 ml-2">
                    <p>{hubName}</p>
                    <p>{hubNumber}</p>
                  </div>
                </div>
                <div>
                  <button title="" data-tooltip="close" style={{ '--tooltip-bg': 'black' }} onClick={handleOrgClose}>
                    <FontAwesomeIcon icon={faX} className="cursor-pointer text-md text-[#f7525a] mx-2" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

{/*       {isNotificationPopupOpen && (
        <div ref={ref} className="absolute right-0 z-50 top-16 bg-white shadow-md border-[#6c7184] rounded-[0.5rem] w-96">
          <div className="p-4 bg-[#fbfbfb]">
            <div className="flex flex-col p-2">
              <div className="flex flex-row justify-between pb-2">
                <p className="font-semibold">Notifications</p>
                <button title="" data-tooltip="close" style={{ '--tooltip-bg': 'black' }} onClick={() => setIsNotificationPopupOpen(false)}>
                  <FontAwesomeIcon icon={faX} className="cursor-pointer text-md text-[#f7525a] mx-2" />
                </button>
              </div>
              <div className="p-2">
                {notifications.length > 0 ? (
                  notifications.map((notification, index) => (
                    <div key={index} className="py-2 border-b border-gray-200">
                      <p className="font-semibold">{notification.title}</p>
                      <p>{notification.body}</p>
                      <p className="text-xs text-gray-500">{notification.time}</p>
                    </div>
                  ))
                ) : (
                  <p>No notifications</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default Navbar;
